<script setup lang="ts">

import {
  Check, RefreshCwOff, X,
} from 'lucide-vue-next';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

import DashboardLayout from '~/layouts/DashboardLayout.vue';
import useUser from '~/store/users/useUser';
import date from '~/utils/date';

const route = useRoute('/users.[id]');

const id = computed(() => route.params.id);

const disableCache = ref(false);

const {
  data: user,
  isFetching: isFetchingUser,
  isLoading: isLoadingUser,
  refetch: refetchUser,
} = useUser(id, disableCache);

async function handleClearCache() {
  disableCache.value = true;
  refetchUser();
}
</script>

<template>
  <DashboardLayout title="Perfil" description="Perfil do usuário" :loading="isLoadingUser || isFetchingUser">
    <template #actions>
      <!-- actions -->
      <div class="btn-list">
        <button
          type="button"
          class="btn btn-secondary loading"
          :disabled="isLoadingUser || isFetchingUser"
          @click="handleClearCache">
          <template v-if="isLoadingUser || isFetchingUser">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
          </template>
          <template v-else>
            <RefreshCwOff class="icon icon-2 spinner" />
            <span>Limpar Cache</span>
          </template>
        </button>
      </div>
      <!-- actions -->

    </template>
    <div class="row gx-2 gy-2">

      <!-- person -->
      <div class="col">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Detalhes da Person </h3>
          </div>
          <div class="card-body">
            <div class="datagrid">
              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">ID</div>
                <div class="datagrid-content"><b>#{{ user?.person.id }}</b></div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">CPF</div>
                <div class="datagrid-content">{{ user?.person.document ?? '-' }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Nome</div>
                <div class="datagrid-content">{{ user?.person.fullname }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Nome de usuário</div>
                <div class="datagrid-content">{{ user?.person.username }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Email</div>
                <div class="datagrid-content">{{ user?.person.contact.email }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Telefone</div>
                <div class="datagrid-content">{{ user?.person.contact.mobile }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Data de nascimento</div>
                <div class="datagrid-content">
                  {{ user?.person.birthdate ? date(user?.person.birthdate).format("LL") : '-' }}
                </div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Ativo</div>
                <div class="datagrid-content">
                  <div v-if="user?.person.active">
                    <Check class="icon icon-2 text-green" /> Sim
                  </div>
                  <div v-else>
                    <X class="icon icon-2 text-red" /> Não
                  </div>
                </div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Perfil</div>
                <div class="datagrid-content">{{ user?.person.profile }}</div>
              </div>

              <!--  -->
              <div class="datagrid-item">
                <div class="datagrid-title">Criado em</div>
                <div class="datagrid-content">{{ date(user?.person.created_at).format("LLLL") }}</div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>
